import {GridColumns} from '@mui/x-data-grid';
import {FormattedMessage} from 'react-intl';
import {ColoredStatus} from 'src/components/common/ColoredStatus';
import {InvoiceNumberLink} from './InvoiceNumberLink';
import {DownloadInvoicePdf} from './DownloadInvoicePdf';
import {InvoiceSortEnum} from 'src/enums';
import {InvoicePreview} from '../InvoicePreview';
import {RevenueInvoicePreview} from '../RevenueInvoicePreview';

/**
 * Which list this is, not who is reading it.
 *
 * A revenue invoice is issued to a business and a business invoice to a person, so the first column
 * names a different thing in each and only one of them has a detail page to link to. Deciding it
 * from the viewer held only while the administrator's page was the revenue list.
 */
export const columnConfigInvoices = (revenue = false): GridColumns => [
    {
        field: 'user',
        renderHeader: (_params) =>
            revenue ? (
                <FormattedMessage id={'businessColumnHeader'}/>
            ) : (
                <FormattedMessage id={'clientColumnHeader'}/>
            ),
        flex: 2,
        minWidth: 50,
        cellClassName: 'ampTableCell',
        renderCell: (params) =>
            revenue ? (
                <RevenueInvoicePreview data={params.row}/>
            ) : (
                <InvoicePreview data={params.row}/>
            ),
    },
    {
        field: InvoiceSortEnum.INVOICE_NUMBER,
        renderHeader: (_params) => <FormattedMessage id={'invoiceNumberColumnHeader'}/>,
        flex: 2,
        minWidth: 50,
        cellClassName: 'ampTableCell',
        renderCell: (params) =>
            revenue ? (
                <>{params.row.invoiceNumber}</>
            ) : (
                <InvoiceNumberLink
                    invoiceId={params.row.id}
                    invoiceNumber={params.row.invoiceNumber}
                />
            ),
    },
    {
        field: InvoiceSortEnum.CREATED,
        renderHeader: (_params) => <FormattedMessage id={'invoiceDateColumnHeader'}/>,
        flex: 5,
        minWidth: 160,
        cellClassName: 'ampTableCell',
        valueGetter: (params) => new Date(params.row.created).toLocaleString('fr-CH'),
    },
    {
        field: InvoiceSortEnum.AMOUNT,
        renderHeader: (_params) => <FormattedMessage id={'invoiceAmountColumnHeader'}/>,
        flex: 3,
        minWidth: 100,
        cellClassName: 'ampTableCell',
        renderCell: (params) => {
            const amount = params.row.bexioAmount || `${params.row.amount / 100}`;
            return <>{`${amount} ${params.row.currency || ''}`}</>;
        },
    },
    {
        field: InvoiceSortEnum.STATUS,
        renderHeader: (_params) => <FormattedMessage id={'invoiceStatusColumnHeader'}/>,
        flex: 2,
        minWidth: 100,
        cellClassName: 'ampTableCell',
        renderCell: (params) => <ColoredStatus label={params.row.status}/>,
    },
    {
        field: 'download invoice',
        headerName: '',
        width: 120,
        sortable: false,
        cellClassName: 'ampTableCell',
        align: 'right' as const,
        headerAlign: 'right' as const,
        renderCell: (params) =>
            params?.row?.bexioId && (
                <DownloadInvoicePdf
                    name={params.row.invoiceNumber}
                    invoiceId={params.row.id}
                    revenue={revenue}
                    businessId={revenue ? params?.row?.business?.id : undefined}
                    userId={params.row.user?.id}
                    isIcon
                />
            ),
    },
];
